const COMMON_PPREFIX = "store/loadingReducer";

export const ADD_LOADER = `${COMMON_PPREFIX}/ADD_LOADER`;
export const HIDE_LOADER = `${COMMON_PPREFIX}/HIDE_LOADER`;
